/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Paths_Online_TitleInputs */

const en_fc_home_paths_online_title = /** @type {(inputs: Fc_Home_Paths_Online_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use online`)
};

/**
* | output |
* | --- |
* | "Use online" |
*
* @param {Fc_Home_Paths_Online_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_paths_online_title = /** @type {((inputs?: Fc_Home_Paths_Online_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Paths_Online_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_paths_online_title(inputs)
});
export { fc_home_paths_online_title as "fc.home.paths.online.title" }